<div class="modal-admin">
  <div class="header">
    <p class="close" (click)="cancel()"><img src="./assets/logos/close.svg" alt=""></p>
    <p class="title">{{data.title}}</p>
  </div>
  <div class="body" *ngIf="form && formFields">
    <form [formGroup]="form">
      <div class="input-control-error" *ngFor="let formField of formFields" [ngClass]="{ 'half': data.formFields[formField].half}">
        <label for="{{formField}}">{{data.formFields[formField].text}}</label>
        <mat-form-field [ngStyle]="{'width': '100%'}" *ngIf="data.formFields[formField].values">
          <select [formControlName]="formField" id="{{formField}}" required class="input-search" matNativeControl
            [ngClass]="{'error-input': formSubmitted && form.controls[formField].invalid}">
            <option *ngFor="let option of data.formFields[formField].values" [value]="option.value">
              {{option.text}}
            </option>
          </select>
        </mat-form-field>
        <!-- <select *ngIf="data.formFields[formField].values" class="input-search"
          [ngClass]="{'error-input': formSubmitted && form.controls[formField].invalid}" [formControlName]="formField"
          id="{{formField}}" style="width: 98%; height: 51px;" required>
          <option *ngFor="let option of data.formFields[formField].values" [value]="option.value">{{option.text}}
          </option>
        </select> -->
        <input type="text" id="{{formField}}" *ngIf="!data.formFields[formField].values"
          [ngClass]="{'error-input': formSubmitted && form.controls[formField].invalid}"
          class="input-search" [formControlName]="formField" placeholder="" required>
        <div class="div-error" *ngIf="formSubmitted && form.controls[formField].invalid">
          Campo obligatorio
        </div>
      </div>
    </form>
    <div class="submit-button bottom">
      <button id="submitCreateReport" (click)="submitForm()">{{data.buttonText}}</button>
    </div>

  </div>